module.exports = __webpack_public_path__ + "img/profile_teo_logo.17fb1eb1.png";